import { toNumberOrZero } from '~/utils/functions';
import { sumItensCents } from '../../utils';
import { applyStAdjustment } from '../corrigirDifST';
import { ItemNFProps } from '../../protocols/ItemNFProps';

export type DiffKey = 'val_icms_st' | 'val_ipi';
export const sumReprocessoCents = (items: any[], key: DiffKey) => {
  const REPROCESSO = `${key}_REPROCESSO` as const;

  const tmp = items.map((it) => ({
    ...it,
    [key]: toNumberOrZero(it?.[REPROCESSO]),
  }));

  return sumItensCents(tmp, key);
};

export const runAdjustmentSimulation = (
  itens: ItemNFProps[],
  targetCents: number,
  key: DiffKey,
) => {
  const ORIGINAL = `${key}_ORIGINAL` as const;
  const REPROCESSO = `${key}_REPROCESSO` as const;

  // 1) Cria as duas colunas (ORIGINAL + REPROCESSO)
  const base = itens.map((it) => ({
    ...it,
    [ORIGINAL]: toNumberOrZero((it as any)[key]),
    [REPROCESSO]: toNumberOrZero((it as any)[key]),
  })) as any[];

  // 2) Faz a simulação aplicando a correção em cima do campo "real" (key),
  // mas alimentado com o valor REPROCESSO
  const tmp = base.map((it) => ({
    ...it,
    [key]: toNumberOrZero(it[REPROCESSO]),
  })) as ItemNFProps[];

  const { updated, residualCents, reason } = applyStAdjustment(
    tmp,
    targetCents,
    key,
  );

  // 3) Devolve mantendo:
  // - ORIGINAL intocado
  // - REPROCESSO com o valor recalculado
  // - key volta a ser ORIGINAL (para garantir que nada foi aplicado de verdade)
  const simulated = (updated as any[]).map((it) => ({
    ...it,
    [REPROCESSO]: toNumberOrZero(it[key]),
    [key]: toNumberOrZero(it[ORIGINAL]),
  })) as ItemNFProps[];

  return { simulated, residualCents, reason };
};

export const commitSimulation = (itens: ItemNFProps[], key: DiffKey) => {
  const REPROCESSO = `${key}_REPROCESSO` as const;
  const ORIGINAL = `${key}_ORIGINAL` as const;

  // Ao confirmar: grava REPROCESSO em key e (opcional) remove as colunas auxiliares
  return itens.map((it: any) => {
    const committed = {
      ...it,
      [key]: toNumberOrZero(it[REPROCESSO]),
    };

    // se você quiser limpar “colunas temporárias” após confirmar:
    delete committed[REPROCESSO];
    delete committed[ORIGINAL];

    return committed as ItemNFProps;
  });
};
